import React from 'react';
import { Card, Divider, Input } from '@nextui-org/react';
import Typography from '../common/Typography';
import Button from '../common/Button';
import { ProductWithPrice } from '../../../types/stripe';
import { ButtonVariant } from '../../../types/theme';
import { getPlanRecurringPeriod } from '../../../helpers/stripeUtils';

interface IProductRecapCard {
  promoCode?: string;
  onSubmit: () => void;
  product: ProductWithPrice;
  submitTitle: string;
  loading: boolean;
  onPromoCodeChange?: (val: string) => void;
  submitVariant?: ButtonVariant;
  disabled?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export default function ProductRecapCard({
  onSubmit,
  promoCode,
  product,
  loading,
  submitTitle,
  onPromoCodeChange,
  submitVariant = 'secondary',
  className,
  style,
  disabled = false,
}: IProductRecapCard) {
  return (
    <Card className={`flex-1 p-6 ${className ?? ''}`} style={style}>
      <div className='flex flex-col gap-1'>
        <Typography>Piano scelto</Typography>
        <Typography variant='headline3'>{product.name}</Typography>
        <Typography variant='label' colorVariant='textLabel'>{product.description}</Typography>
        <div className='flex justify-between'>
          <Typography>Costo piano</Typography>
          <Typography>
            {((product.default_price.unit_amount ?? 0) / 100).toFixed(2).replace('.', ',')} € / {getPlanRecurringPeriod(product.default_price)}
          </Typography>
        </div>
      </div>
      <Divider className='my-14' />
      <div className='flex flex-col gap-4'>
        <div className='flex flex-row justify-between px-1'>
          <p className='text-base font-bold'>Totale di oggi</p>
          <p className='text-base font-bold'>{(product.default_price.unit_amount ?? 0) / 100} €</p>
        </div>
        <Button
          variant={submitVariant}
          onClick={onSubmit} 
          disabled={loading || disabled} 
          loading={loading} 
          title={submitTitle} />
      </div>
    </Card>
  )
}